const fancybox = require('@fancyapps/fancybox');
  import FixedNav from './custom-modules/FixedNav';
  // // // import GoogleMap from './custom-modules/GoogleMap';
  // // // const googleMap = new GoogleMap();
  // // const fixednav = new FixedNav();
  // import FlyoutNavigation from './custom-modules/FlyoutNavigations';
  import MobileMenu from './custom-modules/MobileMenu';
  import SmoothScroll from './custom-modules/SmoothScroll';
  import Tabs from './custom-modules/Tabs';
  // import FormSubmit from './custom-modules/FormSubmit';

  import Rotate from './custom-modules/Rotate';
//  import LoginModal from './custom-modules/LoginModal';
  import Slider from './custom-modules/PostSlider';
  const smoothScroll = new SmoothScroll();
  const mobileMenu = new MobileMenu();
  const fixedNav = new FixedNav();
  import LoadMoreInsights from './custom-modules/LoadMoreInsights';
  // import FilterPortfolio from './custom-modules/FilterPortfolio';
  // import toggleTeam from './custom-modules/Team';
  // import closeTeamMemberProfile from './custom-modules/CloseTeam';
  // import togglePortfolio from './custom-modules/TogglePortfolio';
  // import toggleText from './custom-modules/ToggleText';
  import FilterInsights from './custom-modules/FilterInsights';
  import TeamTabs from './custom-modules/TeamTabs';

  import InitAnimation from './custom-modules/InitAnimation';
  import AnimateValue from './custom-modules/AnimateValue';
  import LogoSlider from './custom-modules/LogoSlider';
  import skipLinkFocus from './custom-modules/SkipLinkFocus';
  import InitSlideAnimation from './custom-modules/InitSlideAnimation';

  import SearchGastops from './custom-modules/SearchGastops';

  import accessibility from './custom-modules/Accessibility';

  SearchGastops();

  InitSlideAnimation();
  skipLinkFocus();
  AnimateValue();
  const slider = new Slider();
  LoadMoreInsights();
  // FilterPortfolio();
  // toggleTeam();
  // closeTeamMemberProfile();
  // togglePortfolio();
  // toggleText();
  FilterInsights();


  // FlyoutNavigation();
  // FormSubmit();
  Tabs();
  Rotate();
  TeamTabs();
  InitAnimation();
  AnimateValue();
  LogoSlider();

  
  // slider();

  accessibility();